// extracted by mini-css-extract-plugin
export default {"buttonSection":"ViewApplication_buttonSection__+DY1V","publishButton":"ViewApplication_publishButton__2qdMM","closeButton":"ViewApplication_closeButton__hFumA"};